import { useQuery } from '@tanstack/react-query';
import { fetchAgreementCashPosition } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

/** Not gated on invoice.add: the Selection section renders for every tab viewer. */
export function useAgreementCashPositionQuery(id: string | undefined, enabled: boolean) {
    return useQuery({
        queryKey: agreementKeys.cashPosition(id ?? ''),
        queryFn: () => fetchAgreementCashPosition(id!),
        enabled: !!id && enabled,
        // Stale on remount, but no focus refetch: the server re-checks the balance
        // on submission, and a focus refetch would drop the over-balance section.
        staleTime: 0,
        refetchOnWindowFocus: false,
    });
}
